<template>
  <div>
    <div class="sidebar">
      <el-scrollbar>
        <el-menu
          class="el-menu-vertical-demo"
          text-color="#333"
          background-color="#2A3141"
          :router="true"
          style="flex: 1"
          :default-active="this.$route.path"
          :collapse="isCollapse"
        >
          <div v-for="item in routerList" :key="item.path">
            <sidebarItem
              :item="item"
              :router="true"
              v-if="
                ((!item.meta.isparent || parentId == '0') && !item.meta.islawyer) || (item.meta.islawyer && lawyerStatus==1)
              "
            ></sidebarItem>
          </div>
        </el-menu>
      </el-scrollbar>
      <div class="navMask" v-if="navBarMaskShow" @click="$store.dispatch('routerInfo/setNavBarMask')"></div>
    </div>
    <div class="slideChild" v-if="!isHome">
      <ul>
        <li
          v-for="(item, index) in slideChild"
          :key="index"
          @click="gopage(item)"
          :class="{ isActive: item.meta.title === metaName }"
          v-if="!item.meta.isWxpay || item.meta.isWxpay===''"
        >
          <div>
            <span></span>
            {{ item.meta.title }}
          </div>
        </li>
      </ul>
      <div class="navMask" v-if="navBarMaskShow" @click="$store.dispatch('routerInfo/setNavBarMask')"></div>
    </div>
  </div>
</template>
<script>
import { RouteData } from '@/utils/routerList'
import sidebarItem from './slideBarItem'
import { mapState, mapActions } from 'vuex'
import { set, get } from '@/utils/localStorage'

export default {
  components: { sidebarItem },
  props: {
    isHome:{
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isRouter: true,
      isunique: true,
      isCollapse: true,
      routerList: RouteData,
    }
  },
  created() {
  },
  mounted() {},
  computed: {
    parentId(){
      return this.$getlocalStorage('userData').parentId
    },
    ...mapState({
      slideChild: (state) => {
        let childRouter = state.routerInfo.routerArray
        let newArray = []
        if (get('userData').parentId == '0') {
          newArray = childRouter
        } else {
          childRouter.forEach((item, index) => {
            if (!item.meta.isparent) {
              newArray.push(item)
            }
          })
        }
        return newArray
      },
      metaName: (state) => state.routerInfo.metaName,
      lawyerStatus: (state) => state.lawyer.lawyerStatus,
      navBarMaskShow: (state) => state.routerInfo.navBarMaskShow,
    }),
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },
  methods: {
    gopage(item) {
        zhuge.track(`用户中心_${item.meta.title}`, {'渠道': this.channelCodeValue})
      if (item.meta.navTo) {
        // 跨模块导航：跳转到目标路径并切换左侧导航
        this.$store.dispatch('routerInfo/setRouter', {
          basicName: 'invoice',
          basicRoute: this.routerList,
          basicTitle: item.meta.title,
          basicPath: item.meta.navTo,
        })
        this.$router.push({ path: item.meta.navTo })
        return
      }
      item.href
        ? (window.location.href = process.env.VUE_APP_USERCENTERUI + item.href)
        : this.$router.push({ path: item.path })
    },

  },
  beforeUpdate: function() {},
}
</script>
<style>
.sidebar {
  z-index: 999;
}
.sidebar .el-submenu__icon-arrow {
  right: 34px;
  top: 41%;
}

.sidebar .el-submenu__title {
  padding: 0 !important;
}

.sidebar .el-submenu__title:hover {
  background: none !important;
}
</style>

<style scoped lang="less">
.logo {
  text-align: center;
  padding: 30px 0 37px;

  img {
    width: 64px;
    height: 64px;
  }

  .p1 {
    font-size: 18px;
    font-weight: bold;
  }

  .p2 {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }

  /deep/ .el-divider--horizontal {
    width: 55%;
    margin: 10px auto;
  }
}

.el-menu {
  border: none;
}

.father-nav {
  line-height: 43px;
  padding: 0 21px;
  height: 43px;
  background: #f6f7f9;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  border-radius: 7px;
  font-size: 16px;
  color: #6288fb;
}

@bule_bc: #3f7df7;

.slideChild {
  box-sizing: border-box;
  background-color: #fff;
  width: 126px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 100px;
  top: 0;
  padding-top: 98px;
  font-size: 14px;
  text-align: center;
  line-height: 34px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  z-index: 998;

  ul {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
  }

  

  li {
    padding-left: 16px;
    div {
      height: 52px;
      line-height: 52px;
      display: flex;
      align-items: center;
      span {
        display: block;
        width: 5px;
        height: 5px;
        background: #000;
        border-radius:3px;
        margin-right: 7px;
      }
    }
    &.isActive{
      div{
        span{
          background: @bule_bc;;
        }
      }
    }

    &:hover {
      color: @bule_bc;
      cursor: pointer;
      opacity: 1;

      .icrle {
        background: @bule_bc;
      }
    }
  }
}

.isActive {
  color: @bule_bc;
}
</style>
